import { CheckIcon, TriangleDownIcon } from "@chakra-ui/icons";
import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Checkbox,
  Heading,
  HStack,
} from "@chakra-ui/react";
import { NotificationPreferenceSubcategoryFormProps } from "@ui/application/forms";
import { DescriptionPopover } from "./description-popover";
import { PreferenceItem } from "./preference-item";

export const PreferenceSubcategory = (
  props: NotificationPreferenceSubcategoryFormProps,
) => {
  const { title, description, topic, category, preferences, handleChange } =
    props;
  return (
    <AccordionItem
      border="none"
      mx={{ base: "3", md: "10" }}
      my={{ base: "0", md: "3" }}
    >
      {({ isExpanded }: { isExpanded: boolean }) => (
        <>
          <AccordionButton py={{ base: "3", md: "6" }}>
            <HStack flex="1" textAlign="start">
              <Checkbox
                name={title}
                size="lg"
                colorScheme="green"
                aria-label={"Subscribe to all " + title + " Notifications"}
                defaultChecked={preferences.every(
                  (preference) => preference.value,
                )}
                isChecked={preferences.every((preference) => preference.value)}
                icon={<CheckIcon />}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  preferences.forEach((preference) =>
                    handleChange(category, topic, {
                      ...e,
                      target: {
                        ...e.target,
                        name: preference.name,
                      },
                    }),
                  )
                }
              />
              {isExpanded ? (
                <TriangleDownIcon color="black" boxSize="3" />
              ) : (
                <TriangleDownIcon
                  color="black"
                  boxSize="4"
                  transform="rotate(-90deg)"
                />
              )}
              <Heading textColor="black" fontSize="md">
                {title}
                <DescriptionPopover description={description as string} />
              </Heading>
            </HStack>
          </AccordionButton>
          <AccordionPanel>
            {preferences.map((preference, id) => (
              <PreferenceItem
                key={`${category}-${topic}-${id}`}
                id={`${category}-${topic}-${id}`}
                title={preference.title}
                description={preference.description}
                isActive={preference.value}
                name={preference.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChange(category, topic, e)
                }
              />
            ))}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
};
